import { render, staticRenderFns } from "./deletePrinterRuleFee.vue?vue&type=template&id=413a0152&scoped=true"
import script from "./deletePrinterRuleFee.vue?vue&type=script&lang=js"
export * from "./deletePrinterRuleFee.vue?vue&type=script&lang=js"
import style0 from "./deletePrinterRuleFee.vue?vue&type=style&index=0&id=413a0152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413a0152",
  null
  
)

export default component.exports